(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-popup"] && !Shopify.designMode) return;
  try {
    
  class TrustPopup extends HTMLElement {
    connectedCallback() {
      this.delay = parseFloat(this.dataset.delay) || 5;
      this.reappearDays = parseFloat(this.dataset.reappearDays) || 7;
      this.storageKey = 'trust_popup_dismissed_' + (this.dataset.sectionId || 'default');

      // Inside Shopify theme editor, always show after delay (no cookie suppression)
      this.isEditor = window.Shopify && window.Shopify.designMode;

      if (!this.isEditor && this.isDismissed()) return;

      this.timer = setTimeout(() => this.show(), this.delay * 1000);

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-trust-popup-close]')) {
          // Only intercept buttons, not links — let links navigate
          const tag = e.target.closest('[data-trust-popup-close]').tagName;
          if (tag === 'A') {
            this.dismiss();
            return;
          }
          e.preventDefault();
          this.dismiss();
        }
      });

      document.addEventListener('keydown', this.handleEscape);
    }

    disconnectedCallback() {
      if (this.timer) clearTimeout(this.timer);
      document.removeEventListener('keydown', this.handleEscape);
    }

    handleEscape = (e) => {
      if (e.key === 'Escape' && !this.hidden) this.dismiss();
    };

    isDismissed() {
      try {
        const raw = localStorage.getItem(this.storageKey);
        if (!raw) return false;
        const expires = parseInt(raw, 10);
        return !isNaN(expires) && Date.now() < expires;
      } catch (e) {
        return false;
      }
    }

    show() {
      this.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    dismiss() {
      this.hidden = true;
      document.body.style.overflow = '';
      try {
        const expires = Date.now() + this.reappearDays * 24 * 60 * 60 * 1000;
        localStorage.setItem(this.storageKey, String(expires));
      } catch (e) { /* ignore */ }
    }
  }

  if (!customElements.get('trust-popup')) {
    customElements.define('trust-popup', TrustPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
